import ReactDOMServer from 'react-dom/server';


export const createMarkup = (content) => {
  let formattedContent = (typeof content !== 'string') ? ReactDOMServer.renderToStaticMarkup(content) : content;
  return { __html: formattedContent };
};

export const validateStringOrFunction = (input) => {
  if (typeof input === 'function') {
    return input();
  }
  return input;
};